import { render } from "./LongTextColumn.vue?vue&type=template&id=d2a033a4"
import script from "./LongTextColumn.vue?vue&type=script&lang=js"
export * from "./LongTextColumn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__